import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  disableControls,
  enableControls,
  resetControls,
} from '@sharedModule/utils/form.utils';

@Injectable({
  providedIn: 'root',
})
export class FormService {
  disableControls(formGroup: FormGroup, controls: string[] | string): void {
    return disableControls(formGroup, controls);
  }

  enableControls(formGroup: FormGroup, controls: string[] | string): void {
    return enableControls(formGroup, controls);
  }

  resetControls(formGroup: FormGroup, controls: string[] | string): void {
    return resetControls(formGroup, controls);
  }
}
